import AudioMessage from 'components/UI/AudioMessage/AudioMessage'

import styles from './mediaItemAudio.module.scss'

interface Props {
    url: string
}

export const MediaItemAudio = ({ url }: Props) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AudioMessage
                    audioBlob={url}
                    audioReady={true}
                    waveColor='gray'
                    waveBackgroundColor='transparent'
                />
            </div>
        </div>
    )
}
